import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { applyAppUpdateIfIdle } from '../pwa/appUpdate';

/**
 * Applies a pending update on client-side route changes. The user has just
 * left the screen they were on, so a full load of the new route in place of
 * the SPA transition is the least disruptive moment available while the tab
 * stays visible. Must render inside the router.
 */
const useApplyAppUpdateOnNavigate = () => {
  const { pathname } = useLocation();
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    applyAppUpdateIfIdle('navigation');
  }, [pathname]);
};

export default useApplyAppUpdateOnNavigate;
